import { WhatsappAuthLinkTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const WhatsappAuthLinkTrackingSchema: Record<
  WhatsappAuthLinkTrackingPoint,
  string
> = {
  [WhatsappAuthLinkTrackingPoint.PageView]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkOpenWhatsappClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkHelpClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkBackButton]: '',
  [WhatsappAuthLinkTrackingPoint.ResendWhatsappAuthLinkImpression]: '',
  [WhatsappAuthLinkTrackingPoint.ResendWhatsappAuthLinkClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkTryAnotherMethodClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkTryAnotherMethodImpression]:
    '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithOtherMethodImpression]:
    '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithOtherMethodsClick]:
    '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPhoneImpression]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPhoneClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithBiometricsImpression]:
    '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithBiometricsClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPasswordImpression]:
    '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithPasswordClick]: '',
  [WhatsappAuthLinkTrackingPoint.WhatsappAuthLinkLoginWithQuickLoginClick]: '',
};

export const getWhatsappAuthLinkPageTypeAndSchema = (
  trackingPoint: WhatsappAuthLinkTrackingPoint
) => {
  return {
    page_type: PageType.WhatsappAuthLink,
    schema: WhatsappAuthLinkTrackingSchema[trackingPoint],
  };
};
